import React, { useMemo } from "react";
import { motion } from "framer-motion";

// Glassmorphic dark panel used for stat cards, applications, product cards.
const GlassCard = ({ children, className = "", tilt = false, accent = "cyan", as: Comp = "div", ...props }) => {
  const accentClass = accent === "amber" ? "glass-panel-amber" : "";
  // IMPORTANT: motion(Comp) must stay referentially stable across renders -
  // recreating it every render gives React a "new" component type each time,
  // which force-remounts this card's entire subtree (e.g. any <input> inside
  // loses focus/cursor position after every keystroke).
  const MotionComp = useMemo(() => motion(Comp), [Comp]);
  return (
    <MotionComp
      className={`glass-panel rounded-2xl ${accentClass} ${className}`}
      whileHover={tilt ? { rotateX: -3, rotateY: 3, scale: 1.02 } : { scale: 1.01 }}
      transition={{ type: "spring", stiffness: 200, damping: 18 }}
      style={tilt ? { transformStyle: "preserve-3d" } : undefined}
      {...props}
    >
      {children}
    </MotionComp>
  );
};

export default GlassCard;
